import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export enum ErrorSeverity {
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
    Critical = 'critical',
    Success = 'success',
}

@Component({
    selector: 'informational-dialog-v2',
    templateUrl: './informational-dialog-v2.component.html',
    styleUrls: ['./informational-dialog-v2.component.scss'],
})
export class InformationalDialogV2Component {
    @Output() buttonClicked = new EventEmitter<void>();

    constructor(
        public dialogRef: MatDialogRef<InformationalDialogV2Component>,
        public translate: TranslateService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            body?: string;
            errorSeverity?: ErrorSeverity;
            buttonText?: string;
        },
    ) {}

    getIconClass() {
        switch (this.data.errorSeverity) {
            case ErrorSeverity.Info:
                return 'icon-warning info';
            case ErrorSeverity.Warning:
                return 'icon-warning warning';
            case ErrorSeverity.Error:
                return 'icon-warning error';
            case ErrorSeverity.Critical:
                return 'icon-warning critical';
            case ErrorSeverity.Success:
                return 'icon-check-circle success';
            default:
                return 'icon-check-circle success';
        }
    }

    close(): void {
        this.dialogRef.close();
    }

    onButtonClick(): void {
        this.buttonClicked.emit();
        this.close();
    }
}
